<template>
  <div>
    <slot />
    <div class="tw-font-light tw-text-red-500 tw-text-xs tw-h-5" v-if="rules.length">
      <transition
        enter-class="tw--translate-y-full"
        enter-active-class="tw-ease-out tw-duration-300"
        enter-to-class="tw-translate-y-0"
        leave-class="tw-translate-y-0"
        leave-active-class="tw-ease-in tw-duration-100"
        leave-to-class="tw--translate-y-full"
      >
        <div class="tw-transition-transform tw-transform" v-show="errors.length">{{ message }}</div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      leavingMessage: "",
    };
  },
  computed: {
    message() {
      return this.leavingMessage || (this.errors.length ? this.errors[0] : "");
    },
  },
  watch: {
    errors(newVal, oldVal) {
      if (!newVal.length && oldVal.length) {
        this.leavingMessage = oldVal[0];
        setTimeout(() => {
          this.leavingMessage = "";
        }, 200);
      }
    },
  },
};
</script>
